import avail from "./steps/availability.jst";
import btns from "./steps/profileButtons.jst";
import gapRow from "./steps/gapRow.jst";
import history from "./steps/history.jst";
import historyButtons from "./steps/historyProfileButtons.jst";
import historyGutCheck from "./steps/history-gut-check.jst";
import historyGutCheckIntro from "./steps/history-gut-check-step-intro.jst";
import info from "./steps/info.jst";
import jobRow from "./steps/jobRow.jst";
import promo from "./steps/promo.jst";
import signup from "./steps/signup.jst";
import login from "./steps/login.jst";
import suggestions from "./steps/suggestions.jst";
import suggestionsTest from "./steps/suggestions-test.jst";
import summary from "./steps/summary.jst";
import review from "./steps/review.jst";
import reviewAuth from "./steps/reviewAuth.jst";
import company from "./steps/company.jst";

export default {
    Avail: avail,
    Info: info,
    SignUp: signup,
    LogIn: login,
    JobRow: jobRow,
    History: history,
    HistoryBtns: historyButtons,
    GapRow: gapRow,
    HistoryGutCheck: historyGutCheck,
    HistoryGutCheckIntro: historyGutCheckIntro,
    Promo: promo,
    Btns: btns,
    Review: review,
    ReviewAuth: reviewAuth,
    Summary: summary,
    Suggestions: suggestions,
    SuggestionsTest: suggestionsTest,
    Company: company,
};
